'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Newspaper = require('./Newspaper');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Newspaper).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Newspaper/index.js
// module id = 1242
// module chunks = 1